import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Input } from '@/components/ui/input';

interface UserEmailFilterProps {
  filterIndex: number;
}

/**
 * Renders a text input for filtering sessions by user email
 */
export const UserEmailFilter = ({ filterIndex }: UserEmailFilterProps) => {
  const { t } = useTranslation();
  const { getValues, control } = useFormContext();

  const { update } = useFieldArray({ control, name: 'filters' });

  const userEmail = useWatch({ control, name: `filters.${filterIndex}.userEmail` }) || '';

  const handleUserEmailChange = (value: string) => {
    const currentFilter = getValues(`filters.${filterIndex}`);
    update(filterIndex, { ...currentFilter, userEmail: value });
  };

  return (
    <Input
      id={`user-email-${filterIndex}`}
      type="email"
      placeholder={t('analytics.filters.userEmailPlaceholder')}
      value={userEmail}
      onChange={(e) => handleUserEmailChange(e.target.value)}
      className="w-full"
    />
  );
};
